module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.locationIsEditable || _vm.file || _vm.locationHasPhoto || _vm.alwaysEditable) ? _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-lg-8"
  }, [((_vm.file || _vm.locationHasNoPhoto) && (_vm.locationIsEditable || _vm.alwaysEditable)) ? _c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Map Photo")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Map Photo",
      "disabled": ""
    },
    domProps: {
      "value": _vm.file ? _vm.file.name : null
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.file && _vm.locationHasPhoto) ? _c('div', {
    staticClass: "btn-group btn-group-sm",
    attrs: {
      "role": "group"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": _vm.location.photo_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" View Photo")]), _vm._v(" "), _vm._t("delete")], 2) : _vm._e()])]), _vm._v(" "), (_vm.locationIsEditable || _vm.alwaysEditable) ? _c('div', {
    staticClass: "col-sm-12 col-lg-4"
  }, [_c('label', {
    staticClass: "btn btn-primary btn-sm btn-block",
    attrs: {
      "for": "map_photo"
    }
  }, [_c('input', {
    staticClass: "sr-only",
    attrs: {
      "type": "file",
      "id": "map_photo",
      "name": "file",
      "accept": ".jpg,.jpeg,.png,.gif"
    },
    on: {
      "change": _vm.handleFileSelection,
      "input": _vm.handleFileSelection
    }
  }), _vm._v("\n        Select File\n      ")])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-47bd096f"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/locations/Photo.vue
// module id = 989
// module chunks = 0